import { appMixin } from '../utils/appMixin';

export class Controller extends appMixin() {
  _setDefaults() {}

  onAttach() {}

  open = () => {};
}
